module.exports = __webpack_public_path__ + "src/assets/login_logo.png";